import { validatePasswordStrength } from 'anchor-password-policy';
export const passwordPolicyTextsPath = 'common.validation';
export function validatePassword(password, userInputs, texts) {
    return validatePasswordStrength(password, userInputs) || texts.passwordNotStrongEnough();
}
